let Api = {

	"BIGDATA_RESOURCE_STATISTIC": "/simple-api/n/xl/bigdata/resource/statistic", //种植统计数据(加工企业数量)
	"BIGDATA_TIMEAXIS": "/simple-api/n/xl/bigdata/timeAxis", //时间轴
	"BIGDATA_RESOURCE_PLANTAREA": "/simple-api/n/xl/bigdata/resource/plantArea", //乡镇山楂种植面积(亩)
	"BIGDATA_RESOURCE_TOTALOUTPUTLIST": "/simple-api/n/xl/bigdata/resource/totalOutputList", //乡镇山楂产量(吨)
	"BIGDATA_RESOURCE_JGOUTPUTVALUE": "/simple-api/n/xl/bigdata/resource/jgOutPutValue", //加工类产品产值(亿)
	"BIGDATA_RESOURCE_SINGLEPLANTLIST": "/simple-api/n/xl/bigdata/resource/singlePlantList", //乡镇山楂单株产量(斤)
	"BIGDATA_RESOURCE_JGPRODNUM": "/simple-api/n/xl/bigdata/resource/jgProdNum", //加工类产品数量(个)
	"BIGDATA_RESOURCE_SHHZZLIST": "/simple-api/n/xl/bigdata/resource/shhzzList", //社会化服务组织
	"BIGDATA_RESOURCE_OUTPUTVALUE": "/simple-api/n/xl/bigdata/resource/outputValue", //乡镇山楂产值(万元)
	"BIGDATA_RESOURCE_MAPDATA": "/simple-api/n/xl/bigdata/resource/mapData", //产业资源地图显示信息


	"BIGDATA_HOME_OVERVIEW": "/simple-api/n/xl/bigdata/home/overview", //产业概览
	"BIGDATA_HOME_VARIETY_LISTCOUNTDATA": "/simple-api/n/xl/bigdata/home/variety/listCountData", //大数据品种库


	"BIGDATA_DTJC_CQFBGL": "/simple-api/n/xl/bigdata/dtjc/cqfbgl", //产区分布概览
	"BIGDATA_DTJC_CDHYJGHQ": "/simple-api/n/xl/bigdata/dtjc/cdhyjghq", //产地货源价格行情
	"BIGDATA_DTJC_ZYPZFX": "/simple-api/n/xl/bigdata/dtjc/zypzfx", //主要品种结构分析
	"BIGDATA_DTJC_CQCNZS": "/simple-api/n/xl/bigdata/dtjc/cqcnzs", //产区产能走势
	"BIGDATA_DTJC_PZJGZS": "/simple-api/n/xl/bigdata/dtjc/pzjgzs", //产地主要品种价格走势
	"BIGDATA_DTJC_ZYCPJJ": "/simple-api/n/xl/bigdata/dtjc/zycpjj", //产地主要品种均价
	"BIGDATA_DTJC_XDPFSCJGPAGE": "/simple-api/n/xl/bigdata/dtjc/xdpfscjgPage", //销地批发市场通货价格更多
	"BIGDATA_DTJC_MAPDATA": "/simple-api/n/xl/bigdata/dtjc/mapData", //地图数据
	"BIGDATA_DTJC_QRJGQS": "/simple-api/n/xl/bigdata/dtjc/qrjgqs", //
	
	"BIGDATA_DTJC_XDPFSCJG": "/simple-api/n/xl/bigdata/dtjc/xdpfscjg", //销地批发市场通货价格

	
	
	



	

  

  

}
module.exports = Api